import { ReactNode, useState } from 'react';
import ErrorBoundary from '@/components/Common/error-boundary';

interface SafeWrapperProps {
  children: ReactNode;
  fallbackMessage?: string;
}

/**
 * A simple wrapper component that catches errors and displays a fallback UI
 * This is a simpler alternative to the ErrorBoundary component when you just need
 * basic error handling without all the complexity
 */
export function SafeWrapper({ children, fallbackMessage = 'Something went wrong' }: SafeWrapperProps) {
  return (
    <ErrorBoundary
      fallback={
        <div className="p-4 bg-white rounded-lg shadow-sm border border-white-blue">
          <p className="text-gray-600">{fallbackMessage}</p>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
}
